export const CartIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
    >
        <rect x="0.191406" width="30" height="30" rx="15" fill="#EEEEEE" />
        <g clipPath="url(#clip0_13254_8513)">
            <path
                d="M23.4102 9H10.6914L10.4102 7.625C10.3477 7.28125 10.0352 7 9.69141 7H6.56641C6.34766 7 6.19141 7.1875 6.19141 7.375V8.125C6.19141 8.34375 6.34766 8.5 6.56641 8.5H9.06641L11.2227 19.625C10.8789 20 10.6914 20.4688 10.6914 21C10.6914 22.125 11.5664 23 12.6914 23C13.7852 23 14.6914 22.125 14.6914 21C14.6914 20.6562 14.5664 20.3125 14.4102 20H18.9414C18.7852 20.3125 18.6914 20.6562 18.6914 21C18.6914 22.125 19.5664 23 20.6914 23C21.7852 23 22.6914 22.125 22.6914 21C22.6914 20.4375 22.4414 19.9375 22.0664 19.5625L22.0976 19.4375C22.1914 18.9688 21.8476 18.5 21.3476 18.5H12.5352L12.2539 17H22.0039C22.3789 17 22.6602 16.7812 22.7539 16.4375L24.1602 9.9375C24.2539 9.46875 23.9102 9 23.4102 9ZM12.6914 21.75C12.2539 21.75 11.9414 21.4375 11.9414 21C11.9414 20.5938 12.2539 20.25 12.6914 20.25C13.0977 20.25 13.4414 20.5938 13.4414 21C13.4414 21.4375 13.0977 21.75 12.6914 21.75ZM20.6914 21.75C20.2539 21.75 19.9414 21.4375 19.9414 21C19.9414 20.5938 20.2539 20.25 20.6914 20.25C21.0976 20.25 21.4414 20.5938 21.4414 21C21.4414 21.4375 21.0976 21.75 20.6914 21.75ZM21.4102 15.5H11.9414L10.9727 10.5H22.5039L21.4102 15.5Z"
                fill="#292929"
            />
        </g>
        <defs>
            <clipPath id="clip0_13254_8513">
                <rect
                    width="30"
                    height="30"
                    fill="white"
                    transform="translate(0.191406)"
                />
            </clipPath>
        </defs>
    </svg>
)
